<template>
  <v-text-field
    :value="telefone_formatado"
    v-bind="$attrs"
    maxlength="15"
    @input="onInput"
    @focus="onFocus"
  ></v-text-field>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps(['value']);
const emit = defineEmits(['input']);

const telefone_formatado = ref("");
const teste = ref("");

const onInput = (value) => {
  let telefone = value;
  telefone = formatarTelefone(telefone);

  telefone_formatado.value = telefone;
};

const onFocus = (event) => {
  setTimeout(function () {
    event.target.select();
  }, 0);
};

watch(telefone_formatado, (value) => {
  emit('input', value)
})

watch(() => props.value, (value) => {
    telefone_formatado.value = value;
  },
  { immediate: true }
)

const formatarTelefone = (telefone) => {
  telefone = telefone.replace(/\D/g, "");
  const telefone_length = telefone.length;

  telefone = telefone.replace(/^(\d{2})/, "$1");
  telefone = telefone.replace(/^(\d{2})(\d)/, "($1) $2");
  if (telefone_length > 10) {
    telefone = telefone.replace(/^\((\d{2})\) (\d{5})(\d)/, "($1) $2-$3");
  } else {
    telefone = telefone.replace(/^\((\d{2})\) (\d{4})(\d)/, "($1) $2-$3");
  }
  return telefone;
};

function formatPhoneNumber(phoneNumber) {
    // Remove todos os caracteres não numéricos
    const cleaned = phoneNumber.replace(/\D/g, '');

    // Aplica a máscara
    const match = cleaned.match(/^(\d{0,2})(\d{0,5})(\d{0,4})$/);
    if (match) {
        // Formata o número no formato desejado
        return (!match[2] ? match[1] : '(' + match[1] + ') ') +
            (match[2] ? match[2] + '-' : '') +
            (match[3] ? match[3] : '');
    }

    // Se não corresponder ao formato esperado, retorna o número original
    return phoneNumber;
}

</script>

<style scoped>

</style>
